"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingScene = void 0;
const pixi_js_1 = require("pixi.js");
const inversify_1 = require("inversify");
const GameConfig_1 = require("../Core/GameConfig");
const SymbolClasses_1 = require("../Utils/SymbolClasses");
const LoadingLayer_1 = require("../Layers/LoadingLayer");
const BackgroundLayer_1 = require("../Layers/BackgroundLayer");
const ReadyScene_1 = require("./ReadyScene");
const SceneSwitcher_1 = require("./SceneSwitcher");
const RawMap_1 = require("../Core/RawMap");
const AudioCtx_1 = require("../Common/AudioCtx");
function howlerMiddleware(resource, next) {
    if (resource.loadType !== pixi_js_1.LoaderResource.LOAD_TYPE.AUDIO) {
        return next();
    }
    AudioCtx_1.AudioSource.from(fetch(resource.url).then(res => res.blob()))
        .then(audio => {
        resource.data = audio;
        resource.complete();
    })
        .catch(err => {
        resource.error = err;
        resource.abort("load error");
    })
        .finally(next);
}
const mapContentLoadConfig = {
    load: null,
    url: "object:///rawmap",
};
function validateMap(map) {
    if (!RawMap_1.ValidateRawMap(map)) {
        console.error(RawMap_1.ValidateRawMap.errors);
        throw new Error("invalid raw map format");
    }
}
function mapContentMiddleWare(resource, next) {
    return __awaiter(this, void 0, void 0, function* () {
        if (resource.url !== mapContentLoadConfig.url) {
            return next();
        }
        try {
            const res = typeof mapContentLoadConfig.load === "function" ? mapContentLoadConfig.load() : mapContentLoadConfig.load;
            if (!res) {
                throw new Error("Invalid load config");
            }
            const map = yield res;
            validateMap(map);
            resource.data = map;
            resource.complete();
        }
        catch (err) {
            resource.error = err;
            resource.abort("Load error");
        }
        finally {
            next();
        }
    });
}
let LoadingScene = class LoadingScene extends pixi_js_1.Container {
    constructor(ioc, 
    // private stage: MainStage,
    config) {
        super();
        this.ioc = ioc;
        this.loadedcount = 0;
        this.progress = (loader) => {
            this.loadedcount++;
            let count = 0;
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            for (const key in loader.resources)
                count++;
            this.layer.progress.set(this.loadedcount === count ? 1 : this.loadedcount / (count + 3));
        };
        this.loaded = (loader, res) => {
            this.ioc.bind(SymbolClasses_1.Resources).toConstantValue(res);
            const stage = this.ioc.get(SymbolClasses_1.MainStage);
            stage.addChildAt(this.ioc.resolve(BackgroundLayer_1.BackgroundLayer), 0);
            const ready = this.ioc.resolve(ReadyScene_1.ReadyScene);
            const swicher = this.ioc.get(SceneSwitcher_1.SceneSwitcher);
            swicher.switch(this, ready).outEnd.add(remove => {
                this.destroy({ children: true });
                return remove();
            });
        };
        this.alertedError = false;
        this.error = (err, loader, res) => {
            console.error("load ", res, " error:", err);
            if (!this.alertedError) {
                alert("load " + res.url + " error: " + err);
                this.alertedError = true;
            }
        };
        const loader = new pixi_js_1.Loader();
        loader.pre(howlerMiddleware);
        loader.pre(mapContentMiddleWare);
        mapContentLoadConfig.load = config.mapContent;
        loader.add("music", config.musicSrc, { loadType: pixi_js_1.LoaderResource.LOAD_TYPE.AUDIO });
        if (config.backgroundSrc)
            loader.add("background", config.backgroundSrc, { loadType: pixi_js_1.LoaderResource.LOAD_TYPE.IMAGE });
        loader.add("map", mapContentLoadConfig.url, { loadType: pixi_js_1.LoaderResource.LOAD_TYPE.XHR });
        for (const key in GameConfig_1.jsonNames)
            loader.add(key, `${config.skin}/${GameConfig_1.jsonNames[key]}`);
        for (const key in GameConfig_1.soundNames)
            loader.add(key, `${config.sound}/${GameConfig_1.soundNames[key]}`);
        loader.onProgress.add(this.progress);
        loader.onError.add(this.error);
        loader.load(this.loaded);
        this.layer = ioc.resolve(LoadingLayer_1.LoadingLayer);
        this.addChild(this.layer);
    }
};
LoadingScene = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [inversify_1.Container,
        GameConfig_1.GameLoadConfig])
], LoadingScene);
exports.LoadingScene = LoadingScene;
//# sourceMappingURL=LoadingScene.js.map